import React from 'react';
import PropTypes from 'prop-types';

const MenuWrapper = ({ children }) => {
  return <div style={{ minHeight: 100 }}>{children}</div>;
};

MenuWrapper.propTypes = {
  children: PropTypes.array
};

export default MenuWrapper;
